import script from "./BackgroundCropDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./BackgroundCropDialog.vue?vue&type=script&setup=true&lang=js"

import "./BackgroundCropDialog.vue?vue&type=style&index=0&id=a01203f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a01203f0"]])

export default __exports__